/*  ========================================================================
    # Scripts - Icon List Collapse
    ========================================================================  */

/**
 * Script that handles the icon list collapse.
 */
const IconListCollapse = {
  cfg: {
    iconListContainers: document.querySelectorAll('.s-icon-list--collapsable'),
    states: {
      open: 'open'
    }
  },

  /**
   * Initialize all sliders.
   */
  init() {
    if (this.cfg.iconListContainers.length === 0) {
      return;
    }

    this.cfg.iconListContainers.forEach(container => {
      const toggleButton = container.querySelector('.s-icon-list__toggle-button');

      if (toggleButton) {
        toggleButton.addEventListener('click', () => {
          container.classList.toggle(this.cfg.states.open);
          toggleButton.remove();
        });
      }
    });
  }
};

export default IconListCollapse;
